/** W3 animated number (PMA-BCAST-014): counts to the new value, final at 400 ms, no blur. */
import { useEffect, useRef, useState } from "react";

export const ANIMATED_NUMBER_MS = 400;

export function interpolate(
  from: number,
  to: number,
  progress: number,
): number {
  const p = Math.min(1, Math.max(0, progress));
  return from + Math.trunc((to - from) * p);
}

export function AnimatedNumber({
  value,
  durationMs = ANIMATED_NUMBER_MS,
  format,
}: {
  value: number;
  durationMs?: number;
  format?: (n: number) => string;
}) {
  const [shown, setShown] = useState(value);
  const shownRef = useRef(value);
  shownRef.current = shown;

  useEffect(() => {
    const from = shownRef.current;
    if (from === value) return;
    const start = Date.now();
    const id = setInterval(() => {
      const p = (Date.now() - start) / durationMs;
      if (p >= 1) {
        clearInterval(id);
        setShown(value);
        return;
      }
      setShown(interpolate(from, value, p));
    }, 16);
    return () => clearInterval(id);
  }, [value, durationMs]);

  return (
    <span data-testid="animated-number" data-target={value}>
      {format ? format(shown) : shown}
    </span>
  );
}
